import { motion } from 'framer-motion';
import { Card } from '../../../design-system/components';
import SectionHeading from '../components/SectionHeading';

const features = [
  {
    icon: '📚',
    title: 'Structured NVC Course',
    description: `Bite-sized lessons across ${__COURSE_MODULE_COUNT__} modules — from feelings vocabulary to self-empathy and sovereignty — at your own pace.`,
  },
  {
    icon: '🤖',
    title: 'AI Empathy Tutor',
    description:
      'Meet Empy — your 24/7 AI companion trained in Nonviolent Communication. Practice difficult conversations in a safe space.',
  },
  {
    icon: '🤝',
    title: 'Live Empathy Sessions',
    description:
      'Connect with real people in live video sessions. Give and receive empathy with caring community members.',
  },
  {
    icon: '🦒',
    title: 'Giraffe Translator',
    description:
      'Paste any message that feels charged or disconnected and see it reframed in empathic, needs-based language — our AI shows you how to say the same thing in a way that invites connection.',
  },
  {
    icon: '🎮',
    title: 'Interactive Games',
    description:
      'Vocabulary drills, needs-matching games, and quizzes that make learning empathic communication genuinely fun.',
  },
  {
    icon: '📊',
    title: 'Track Your Growth',
    description:
      'Track your learning journey with personal milestones, practice streaks, and detailed analytics that show how your communication skills are growing.',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="ee-landing-section">
      <div className="ee-landing-container ee-landing-container--mid">
        <SectionHeading
          title="Everything You Need to Communicate Better"
          subtitle="A complete toolkit for learning empathic communication — from structured courses to AI-powered practice."
        />

        <div className="ee-landing-grid ee-landing-grid--2 ee-landing-grid--features">
          {features.map((feature, index) => (
            <motion.div
              key={feature.title}
              className="ee-landing-cell"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <Card padding="lg">
                <span className="ee-landing-tile__emoji" aria-hidden="true">
                  {feature.icon}
                </span>
                <h3 className="ee-landing-tile__title">{feature.title}</h3>
                <p className="ee-landing-tile__text">{feature.description}</p>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
